var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x89\xBA (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15 17.2619C7.15 17.5603 7.47656 17.7095 7.71406 17.5305L11.425 14.7552H15.7C16.7391 14.7552 17.6 13.9197 17.6 12.8752V4.31072C17.6 3.26627 16.7687 2.40087 15.7 2.40087H4.3C3.23125 2.40087 2.4 3.23643 2.4 4.31072V12.8752C2.4 13.8898 3.23125 14.7552 4.3 14.7552H7.15V17.2619ZM12.0567 16.6561H15.7C17.7578 16.6561 19.5 14.9999 19.5 12.8752V4.31072C19.5 2.24438 17.8458 0.5 15.7 0.5H4.3C2.17348 0.5 0.5 2.19507 0.5 4.31072V12.8752C0.5 14.9312 2.17348 16.6561 4.3 16.6561H5.25V17.2619C5.25 19.2627 7.47345 20.0871 8.85343 19.0516C8.85479 19.0506 8.85615 19.0496 8.8575 19.0486L12.0567 16.6561Z",
    fill: "#ACB3B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.930c8e2f64869b9a79db27f2776a2f8f.svg";
export { ForwardRef as ReactComponent };